import React from 'react'
import { authRoles } from '../../auth/authRoles'

const dashboardRoutes = [

    
    {
        path: '/dashboard',
        component: React.lazy(() => import('./Dash')),
        auth: authRoles.dashboard,
    },
    // {
    //     path: '/hotelregistration',
    //     component: React.lazy(() => import('./../Temp/HotelRegistration')),
    //     //auth: authRoles.dashboard,
    // },
   
   
   
]

export default dashboardRoutes
